import { ImageProp } from './image';
import { Place } from './place';
import { City } from './city';
import { ActionType } from './action-types';

export const CATEGORIES_STATUS = {
  OPEN: 'OPEN',
  CLOSE_VISIBLE: 'CLOSE_VISIBLE',
  CLOSE_HIDDEN: 'CLOSE_HIDDEN',
};

export interface Quota {
  category: { id: number; title: string };
  is_unlimited: boolean;
  remainder: number;
  status: keyof typeof CATEGORIES_STATUS;
}

export interface EventDate {
  city: City;
  close_sale_timer: number | null;
  event: {
    id: number;
    title: string;
  };
  place: {
    id: string;
    title: string;
  };
  quotas: Quota[];
  start_date: string;
  time: string[];
}

export interface DateEvent {
  end_date: string; // 2022-04-02 yyyy-LL-dd
  start_date: string; // 2022-04-02 yyyy-LL-dd
  time: string[];
}

export interface EventCategory {
  buy_form_text: null;
  discount: null;
  estimation: null;
  event: number;
  fee: string;
  id: number;
  is_active: boolean;
  is_unlimited: boolean;
  max_quantity: number;
  position: number;
  price: string;
  product_bx_id: string;
  quantity: number;
  remainder: number;
  remote_id: string;
  show_remainder: boolean;
  smartbilet_id: null;
  sold: number;
  status: string;
  title: string;
  total_quota: null;
}

export interface CategoryData {
  alias: string;
  count: number;
  description: string;
  header_position: number;
  id: number;
  is_index: boolean;
  parent: null | number;
  seo_description: string;
  seo_h1: string;
  seo_keywords: string;
  seo_title: string;
  show_in_header: boolean;
  slug: string;
  parent_slug?: string | null;
  title: string;
}

export interface Category extends CategoryData {
  children: CategoryData[];
}

export type ActionCategory = Category;

export interface Action {
  archiving_reason?: string;
  age_category: string;
  best_reviews: boolean;
  block_1_description: string;
  block_1_description_html: string | null;
  block_1_title: string;
  block_2_description: string;
  block_2_description_html: string | null;
  block_2_title: string;
  block_descriptions: { block_title: string; block_description_html: string }[];
  buy_form_text: string;
  cancellation_policy:
    | null
    | 'free_cancel'
    | '10_days'
    | 'no_refund'
    | 'discounted_no_refund';
  cerificate_service_fee: string;
  certificate_last_name_required: boolean;
  city: City;
  sponsor: { id: number; title: string } | null;
  comments_avg_rating: number;
  comments_count: number;
  condition: string;
  condition_title: string;
  countdown_datetime: string;
  countdown_tickets: any;
  countdown_type: string;
  date_unknown: boolean;
  dates: {
    close_sale_timer: number;
    end_date: string;
    event: number;
    event_categories: number[];
    first_time: string;
    id: number;
    place: number;
    quotas: {
      category_id: string;
      category_remote_id: string;
      category_title: string;
      is_unlimited: boolean;
      quantity: number;
    }[];
    remote_id: string;
    sale_is_closed: boolean;
    start_date: string;
    time: string[];
  }[];
  dates_txt: string;
  dates_txt_detailed: { [key: string]: string[] }[];
  description: string;
  discount: number | null;
  display_price: string | null;
  duration: string | null;
  event_categories: EventCategory[];
  filter_price: number | null;
  first_time: boolean;
  free_reservation_cancel: boolean;
  has_further_dates: boolean;
  hit: boolean;
  id: number;
  image: ImageProp;
  images: ImageProp[];
  instead_price: number | null;
  latest_event: DateEvent | null;
  marketing_category: string | null;
  max_count_per_user: number;
  nearest_event: DateEvent | null;
  not_season: boolean;
  payment_on_spot: boolean;
  photo_preview: string;
  place_title: string;
  places: Place[];
  premiere: boolean;
  prepayment: boolean;
  price: string;
  price_currency: string;
  price_amount: string;
  purchase_button?: string;
  pushkin_card_payment: boolean;
  remainder: number;
  remote_id: string;
  reservation_by_name_only: boolean;
  reservation_count_text: null | string;
  reservation_type: string;
  seo_description: string;
  seo_title: string;
  service_fee: number | null;
  short_description: string;
  show_remainder: boolean;
  slug: string;
  smartbilet_url: string;
  status: string;
  subscription_confirmed: boolean;
  comments_with_rating_count: number;
  title: string;
  title_short: string;
  tsnext_id: string;
  tsnext_type: string;
  type: ActionType;
  url: string;
  video_cover: string;
  video_url: string;
  views: number;
  widget_script: string;
  with_open_date: boolean;
  ym_open: string;
}

export interface ActionList {
  count: number;
  results: Action[];
  next: string | null;
  currency_stats: {
    count: number;
    max_price: number | null;
    min_price: number | null;
    price_currency: string;
  }[];
}

export const RESERVATION_TYPES = {
  full: 'full',
  shortened: 'shortened',
};

export const QUOTA_REMAINDER_TYPES = {
  unlimited: 'unlimited',
  noTickets: 'noTickets',
  remainderCount: 'remainderCount',
};

export const actionFormFieldsNames = {
  first_name: 'name',
  last_name: 'surname',
  phone_number: 'phone',
  email: 'mail',
  date: 'date',
  time: 'date_time',
  count: 'count',
};

export interface PaymentItem {
  amount: number;
  amount_in_cents: number;
  is_agent_item: boolean;
  name: string;
  name_in_receipt: string;
  price: number;
  price_in_cents: number;
  quantity: number;
}
